module.exports = __webpack_public_path__ + "static/media/matilde-cap-china-scary.abb6dd3d.png";